module.exports = __webpack_public_path__ + "img/checkmate.804de956.png";